import { PaymentStatus, RewardStatus, UserProfile } from '../..';
import { Order } from '../orders';

export enum APP_ACTIONS {
  APP_INIT = 'app/init',
  APP_INIT_AUTH = 'app/init/auth',
  APP_LOGIN = 'app/login',
  APP_LOGOUT = 'app/logout',
  APP_SAVE_STATE = 'app/saveState',
  APP_GET_PROFILE = 'app/getProfile',
  APP_GET_REWARDS = 'app/getRewards',
  APP_SUBMIT_PURCHASES = 'app/submitPurchaseHistory',
  APP_SCAN_PURCHASES_START = 'app/scanPurchases/start',
  APP_SCAN_PURCHASES_STOP = 'app/scanPurchases/stop',
  APP_TABS_ACTIVE = 'app/tabs/active',
  APP_REFRESH_SESSION = 'app/refreshSession',
}

export interface BrowserTab {
  tabId: number;
  url?: string;
}

export interface KnownBrowserTab extends BrowserTab {
  updateAt: string;
  url: string;
  status?: string;
  info: any;
}

export type UrlInfo = { type: string; url: string };
export type PageInfo = string | UrlInfo[];

export interface CustomerRewardsDetails {
  rewardStatus: RewardStatus;
  paymentStatus: PaymentStatus;
  rewardId: string;
  rewardAmount: number;
  rewardCurrency: string;
  updatedTime: string;
}

export interface CustomerRewards extends CreatedUpdated {
  totalRewards: number;
  lockedRewards: number;
  details: CustomerRewardsDetails[];
}

export interface WebsiteContext {
  retailerId: number;
  displayName: string;
  pages: {
    ordersPage: PageInfo;
    homePage: PageInfo;
  };
  context: {
    userId: string;
    [key: string]: string;
  };
  updatedAt: string;
}

export interface RewardSites {
  [domain: string]: WebsiteContext;
}

export interface CreatedUpdated {
  createdAt: string;
  updatedAt: string;
}

export type ScanRequestAndResponse = {
  meta?: {
    year?: number;
    pageNumber?: number;
    orderPageType?: string;
    index?: number;
    requestType?: string;
  };
  method: 'GET' | 'POST' | string | undefined;
  url: string;
  referrer?: string;
  body?: string | Buffer;
  headers?: Record<string, string | string[]>;
  withCredentials?: boolean;
};

export interface SessionAction<T> extends CreatedUpdated {
  type: string;
  sessionId: string;
  id: string;
  tabId: number;
  response?: T;
  displayMessage: string;
  error?: any;
  request: ScanRequestAndResponse;
}

export enum SessionState {
  NONE = 'NONE',
  STARTED = 'STARTED',
  STOPPED = 'STOPPED',
  ENDED = 'ENDED',
  SUBMITTED = 'SUBMITTED',
  ERROR = 'ERROR',
}

export interface Session<T> extends CreatedUpdated {
  id: string;
  retailerId: number;
  state: SessionState;
  actions: SessionAction<T>[];
}

export type OrderScanSession = Session<Order[]>;

export enum AuthStateEnum {
  NONE = 'NONE',
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT',
  LOGIN_EXPIRED = 'LOGIN_EXPIRED',
  SERVER_ERROR = 'SERVER_ERROR',
}

export interface AuthState {
  isAuthenticated: boolean;
  state?: AuthStateEnum;
  profile?: UserProfile;
  token?: string;
  error?: any;
  logInTime: string;
  logOutTime: string;
  updatedTime: string;
}
